module.exports = __webpack_public_path__ + "img/165.01c8c1ff.jpg";